import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ButtonCoreComponent } from '../button-core/button-core.component';

import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-state-layer.js';

@Component({
  standalone: false,
  selector: 'campus-segmented-dropdown-button, [segmented-dropdown-button]',
  templateUrl: './segmented-dropdown-button.component.html',
  styleUrls: ['./segmented-dropdown-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentedDropdownButtonComponent extends ButtonCoreComponent {
  @HostBinding('class')
  defaultClasses = [
    ...this.coreClasses,
    'segmented-dropdown-button',

    'flex',
    'transparent',
    'text-opacity-medium',

    'p-b-3xs',
    'p-i-0',

    'corner-full',
    'border',
    'border-transparent',

    'hover:text-primary',
    'hover:text-opacity-high',

    'selected:ring',
    'selected:ring-primary',
    'selected:ring-2',
    'disabled:opacity-low',
  ];

  @Input() icon = 'cds-comp:arrow-drop-down';
}
